import React, { useState, useCallback, useEffect } from 'react';
import Joyride, { STATUS } from 'react-joyride';

const BuilderRide = ({ steps, children, jrName }) => {
    const [run, setRun] = useState(true);

    const handleJoyRide = useCallback(
        (data) => {
            const { status } = data;
            if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
                localStorage.setItem(jrName, 1);
            }
        },
        [jrName]
    );

    useEffect(() => {
        const jr = localStorage.getItem(jrName);
        if (jr === '1') {
            setRun(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // mounted

    return (
        <div>
            <Joyride
                run={run}
                continuous
                steps={steps}
                showProgress
                showSkipButton
                locale={{ last: 'Close' }}
                callback={handleJoyRide}
                styles={{
                    tooltipContainer: { textAlign: 'left' },
                    options: {
                        textColor: '#464a53',
                        primaryColor: '#0062ff',
                    },
                }}
            />
            {children}
        </div>
    );
};

export default BuilderRide;
